import * as React from 'react';
import { cn } from '../lib/cn';

export function Card({ className, children, ...p }: React.HTMLAttributes<HTMLDivElement>) {
  return <section className={cn('rounded-card border border-line bg-surface shadow-card p-5', className)} {...p}>{children}</section>;
}
/** A block inside a card (prototype tab content): divided from the block above by a thin line; title with CardTitle eyebrow. */
export function Section({ className, children, ...p }: React.HTMLAttributes<HTMLElement>) {
  return <section className={cn('border-t border-line pt-5 first:border-t-0 first:pt-0', className)} {...p}>{children}</section>;
}
/** A card heading: bold ("Available actions") or, with `eyebrow`, the prototype's green uppercase label ("PARTY GRAPH"). */
export function CardTitle({ children, aside, eyebrow = false }: { children: React.ReactNode; aside?: React.ReactNode; eyebrow?: boolean }) {
  return (
    <div className="mb-3 flex items-center justify-between gap-3">
      <h2 className={eyebrow ? 'eyebrow' : 'font-display text-base font-bold text-ink'}>{children}</h2>{aside}
    </div>
  );
}
/** Definition list for read-only details (profile tabs, summaries): prototype small uppercase labels on the left. */
export function Details({ rows }: { rows: Array<[React.ReactNode, React.ReactNode]> }) {
  return (
    <dl className="grid grid-cols-1 items-baseline gap-x-8 gap-y-3 sm:grid-cols-[max-content_minmax(0,1fr)]">
      {rows.map(([k, v], i) => (
        <React.Fragment key={i}>
          <dt className="text-[11px] font-medium uppercase tracking-[.06em] text-ink-3">{k}</dt>
          <dd className="text-ink">{v ?? <span className="text-ink-3">—</span>}</dd>
        </React.Fragment>
      ))}
    </dl>
  );
}

/** Label left, value right, thin dividers (prototype "Costs — shown before you confirm"); the last row can be the total. */
export function SummaryRows({ rows, totalLast = false }: { rows: Array<[React.ReactNode, React.ReactNode]>; totalLast?: boolean }) {
  return (
    <dl className="divide-y divide-line">
      {rows.map(([k, v], i) => {
        const total = totalLast && i === rows.length - 1;
        return (
          <div key={i} className="flex items-baseline justify-between gap-4 py-2">
            <dt className={total ? 'font-semibold text-ink' : 'text-ink-2'}>{k}</dt>
            <dd className={total ? 'whitespace-nowrap text-right font-display text-lg font-bold tabular text-ink' : 'whitespace-nowrap text-right tabular text-ink'}>{v}</dd>
          </div>
        );
      })}
    </dl>
  );
}
